import { useRouter } from 'next/router'

import MockWrapper from '../mock-wrapper/mock-wrapper'

export interface LayoutProps {
  mock?: boolean
  children?: React.ReactNode
}

export interface wrapperProps {
  children?: React.ReactNode
}

export function Layout({ children, mock }: LayoutProps) {
  const { query } = useRouter()
  const market = (query.market as string) || ''
  const lang = market.includes('-') ? market.split('-').pop() : market

  const isJapan = (lang || '').toLowerCase() === 'ja'
  const rootStyle = `my-4 mx-0 ${isJapan ? 'font-ikeajp' : 'font-ikea'}`

  if (mock && lang) {
    return (
      <MockWrapper lang={lang}>
        <div className={rootStyle}>{children}</div>
      </MockWrapper>
    )
  }

  return (
    <>
      <div className={rootStyle}>{children}</div>
    </>
  )
}
